import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { logger } from '@fiverr-private/obs';
import type { OpenFloatingChatDto } from '../types';

/**
 * Sends initial chat data to the personal assistant service.
 * This is a "fire and forget" operation that won't block the UI.
 */
export const sendInitialChatData = (params: OpenFloatingChatDto): void => {
    const { initialData } = params;
    if (!initialData) {
        logger.warn('[Chat Init Service] Missing required fields for chat initialization', {
            params,
        });
        return;
    }

    const { entryPoint, sellerId, gigId } = initialData;

    const url = pathfinder('personal_assistant_post_chat_init');
    const apiCallData = {
        entryPoint,
        sellerId,
        gigId,
    };

    // Fire and forget - don't await to avoid blocking UI
    axios
        .post(url, apiCallData)
        .then(() => {
            logger.info('[Chat Init Service] Successfully sent initial chat data', { data: apiCallData });
        })
        .catch((error) => {
            logger.error('[Chat Init Service] Failed to send initial chat data', {
                error: error instanceof Error ? error.message : 'Unknown error',
                data: apiCallData,
            });
        });
};
